//https://covrprice.com/wp-admin/admin-ajax.php

import {createApi, fetchBaseQuery, retry} from '@reduxjs/toolkit/query/react'
import {getWordpressVars} from "@lib/wordpressVars";

let baseUrl = getWordpressVars().root
baseUrl = baseUrl.replace('wp-json', 'wp-admin');
baseUrl = baseUrl + 'admin-ajax.php';

// Create our baseQuery instance
const baseQuery = fetchBaseQuery({
    baseUrl: baseUrl,
    prepareHeaders: (headers) => {
        const nonce = getWordpressVars().nonce;
        if (nonce) {
            headers.set('X-WP-Nonce', nonce)
        }
        return headers
    },
})

const baseQueryWithRetry = retry(baseQuery, { maxRetries: 1 })

export const wordpressApi = createApi({
    reducerPath: 'wordpressApi',
    baseQuery: baseQueryWithRetry,

    /**
     * Tag types must be defined in the original API definition
     * for any tags that would be provided by injected endpoints
     */
    tagTypes: [],

    endpoints: () => ({}),
})

const wordpressApiEndpoints = wordpressApi.injectEndpoints({
    endpoints: (build) => ({
        collectionQuickAddWishlist: build.mutation({
            query: (issueId) => {
                const payload = {
                    'action': 'collection_quick_add_wishlist',
                    'issue_id': `${issueId}`,
                };
                return {
                    url: ``,
                    method: "POST",
                    body: payload,
                };
            },
        }),
        collectionQuickAdd: build.mutation({
            query: (args) => {
                const payload = {
                    'action': 'collection_quick_add',
                    ...args
                };
                return {
                    url: ``,
                    method: "POST",
                    body: payload,
                };
            },
        }),
    })
});

export const {
    useCollectionQuickAddWishlistMutation,
    useCollectionQuickAddMutation,
} = wordpressApiEndpoints;
